var K = (e, n, t) => {
  if (!n.has(e))
    throw TypeError("Cannot " + t);
};
var le = (e, n, t) => (K(e, n, "read from private field"), t ? t.call(e) : n.get(e)), C = (e, n, t) => {
  if (n.has(e))
    throw TypeError("Cannot add the same private member more than once");
  n instanceof WeakSet ? n.add(e) : n.set(e, t);
}, ve = (e, n, t, r) => (K(e, n, "write to private field"), r ? r.call(e, t) : n.set(e, t), t);
var d = (e, n, t) => (K(e, n, "access private method"), t);
import { M as $e } from "./MeterEntity-128e0f97.mjs";
var w, L, c = { isResourceTiming: !1, isElementTiming: !1, maxTime: 3e4, reportOptions: {} }, P = window, Qe = P.console, y = P.navigator, O = P.performance, te = function() {
  return y.deviceMemory;
}, ne = function() {
  return y.hardwareConcurrency;
}, pe = function() {
  return O && !!O.getEntriesByType && !!O.now && !!O.mark;
}, Pe = "4g", Ie = !1, Be = { value: 0 }, re = { value: { beacon: 0, css: 0, fetch: 0, img: 0, other: 0, script: 0, total: 0, xmlhttprequest: 0 } }, ie = { value: 0 }, Ue = { value: 0 }, he = {}, R = { isHidden: !1, didChange: !1 }, Ve = function() {
  R.isHidden = !1, document.hidden && (R.isHidden = document.hidden, R.didChange = !0);
}, ae = function(e, n) {
  try {
    var t = new PerformanceObserver(function(r) {
      n(r.getEntries());
    });
    return t.observe({ type: e, buffered: !0 }), t;
  } catch (r) {
    Qe.warn("Perfume.js:", r);
  }
  return null;
}, Fe = function() {
  return !!(ne() && ne() <= 4) || !!(te() && te() <= 4);
}, Ge = function(e, n) {
  switch (e) {
    case "slow-2g":
    case "2g":
    case "3g":
      return !0;
    default:
      return Fe() || n;
  }
}, fe = function(e) {
  return parseFloat(e.toFixed(4));
}, N = function(e) {
  return typeof e != "number" ? null : fe(e / Math.pow(1024, 2));
}, Ne = function(e, n, t, r, i) {
  var a, o = function() {
    c.analyticsTracker && (R.isHidden && !["CLS", "INP"].includes(e) || c.analyticsTracker({ attribution: r, metricName: e, data: n, navigatorInformation: y ? { deviceMemory: te() || 0, hardwareConcurrency: ne() || 0, serviceWorkerStatus: "serviceWorker" in y ? y.serviceWorker.controller ? "controlled" : "supported" : "unsupported", isLowEndDevice: Fe(), isLowEndExperience: Ge(Pe, Ie) } : {}, rating: t, navigationType: i }));
  };
  ["CLS", "INP"].includes(e) ? o() : (a = o, "requestIdleCallback" in P ? P.requestIdleCallback(a, { timeout: 3e3 }) : a());
}, Ke = function(e) {
  e.forEach(function(n) {
    if (!(n.name !== "self" || n.startTime < Be.value)) {
      var t = n.duration - 50;
      t > 0 && (ie.value += t, Ue.value += t);
    }
  });
};
(function(e) {
  e.instant = "instant", e.quick = "quick", e.moderate = "moderate", e.slow = "slow", e.unavoidable = "unavoidable";
})(w || (w = {}));
var k, A, Oe, J, oe;
(L = {})[w.instant] = { vitalsThresholds: [100, 200], maxOutlierThreshold: 1e4 }, L[w.quick] = { vitalsThresholds: [200, 500], maxOutlierThreshold: 1e4 }, L[w.moderate] = { vitalsThresholds: [500, 1e3], maxOutlierThreshold: 1e4 }, L[w.slow] = { vitalsThresholds: [1e3, 2e3], maxOutlierThreshold: 1e4 }, L[w.unavoidable] = { vitalsThresholds: [2e3, 5e3], maxOutlierThreshold: 2e4 };
var X = { RT: [100, 200], TBT: [200, 600], NTBT: [200, 600] }, De = function(e, n) {
  return X[e] ? n <= X[e][0] ? "good" : n <= X[e][1] ? "needsImprovement" : "poor" : null;
}, _ = function(e, n, t) {
  Object.keys(n).forEach(function(r) {
    typeof n[r] == "number" && (n[r] = fe(n[r]));
  }), Ne(e, n, null, t || {});
}, E = function(e) {
  var n = e.attribution, t = e.name, r = e.rating, i = e.value, a = e.navigationType;
  t === "FCP" && (Be.value = i), ["FCP", "LCP"].includes(t) && !he[0] && (he[0] = ae("longtask", Ke)), t === "FID" && setTimeout(function() {
    R.didChange || (E({ attribution: n, name: "TBT", rating: De("TBT", ie.value), value: ie.value, navigationType: a }), _("dataConsumption", re.value));
  }, 1e4);
  var o = fe(i);
  o <= c.maxTime && o >= 0 && Ne(t, o, r, n, a);
}, I = function() {
  return window.performance && performance.getEntriesByType && performance.getEntriesByType("navigation")[0];
}, D = function(e) {
  if (document.readyState === "loading")
    return "loading";
  var n = I();
  if (n) {
    if (e < n.domInteractive)
      return "loading";
    if (n.domContentLoadedEventStart === 0 || e < n.domContentLoadedEventStart)
      return "dom-interactive";
    if (n.domComplete === 0 || e < n.domComplete)
      return "dom-content-loaded";
  }
  return "complete";
}, Xe = function(e) {
  var n = e.nodeName;
  return e.nodeType === 1 ? n.toLowerCase() : n.toUpperCase().replace(/^#/, "");
}, W = function(e, n) {
  var t = "";
  try {
    for (; e && e.nodeType !== 9; ) {
      var r = e, i = r.id ? "#" + r.id : Xe(r) + (r.classList && r.classList.value && r.classList.value.trim() && r.classList.value.trim().length ? "." + r.classList.value.trim().replace(/\s+/g, ".") : "");
      if (t.length + i.length > (n || 100) - 1)
        return t || i;
      if (t = t ? i + ">" + t : i, r.id)
        break;
      e = r.parentNode;
    }
  } catch {
  }
  return t;
}, qe = -1, Re = function() {
  return qe;
}, M = function(e) {
  addEventListener("pageshow", function(n) {
    n.persisted && (qe = n.timeStamp, e(n));
  }, !0);
}, G = function() {
  var e = I();
  return e && e.activationStart || 0;
}, T = function(e, n) {
  var t = I(), r = "navigate";
  return Re() >= 0 ? r = "back-forward-cache" : t && (document.prerendering || G() > 0 ? r = "prerender" : document.wasDiscarded ? r = "restore" : t.type && (r = t.type.replace(/_/g, "-"))), { name: e, value: n === void 0 ? -1 : n, rating: "good", delta: 0, entries: [], id: "v3-".concat(Date.now(), "-").concat(Math.floor(8999999999999 * Math.random()) + 1e12), navigationType: r };
}, B = function(e, n, t) {
  try {
    if (PerformanceObserver.supportedEntryTypes.includes(e)) {
      var r = new PerformanceObserver(function(i) {
        Promise.resolve().then(function() {
          n(i.getEntries());
        });
      });
      return r.observe(Object.assign({ type: e, buffered: !0 }, t || {})), r;
    }
  } catch {
  }
}, g = function(e, n, t, r) {
  var i, a;
  return function(o) {
    n.value >= 0 && (o || r) && ((a = n.value - (i || 0)) || i === void 0) && (i = n.value, n.delta = a, n.rating = function(s, u) {
      return s > u[1] ? "poor" : s > u[0] ? "needs-improvement" : "good";
    }(n.value, t), e(n));
  };
}, se = function(e) {
  requestAnimationFrame(function() {
    return requestAnimationFrame(function() {
      return e();
    });
  });
}, $ = function(e) {
  var n = function(t) {
    t.type !== "pagehide" && document.visibilityState !== "hidden" || e(t);
  };
  addEventListener("visibilitychange", n, !0), addEventListener("pagehide", n, !0);
}, ue = function(e) {
  var n = !1;
  return function(t) {
    n || (e(t), n = !0);
  };
}, x = -1, Te = function() {
  return document.visibilityState !== "hidden" || document.prerendering ? 1 / 0 : 0;
}, Q = function(e) {
  document.visibilityState === "hidden" && x > -1 && (x = e.type === "visibilitychange" ? e.timeStamp : 0, Ye());
}, ge = function() {
  addEventListener("visibilitychange", Q, !0), addEventListener("prerenderingchange", Q, !0);
}, Ye = function() {
  removeEventListener("visibilitychange", Q, !0), removeEventListener("prerenderingchange", Q, !0);
}, me = function() {
  return x < 0 && (x = Te(), ge(), M(function() {
    setTimeout(function() {
      x = Te(), ge();
    }, 0);
  })), { get firstHiddenTime() {
    return x;
  } };
}, z = function(e) {
  document.prerendering ? addEventListener("prerenderingchange", function() {
    return e();
  }, !0) : e();
}, ye = [1800, 3e3], be = function(e, n) {
  n = n || {}, z(function() {
    var t, r = me(), i = T("FCP"), a = B("paint", function(o) {
      o.forEach(function(s) {
        s.name === "first-contentful-paint" && (a.disconnect(), s.startTime < r.firstHiddenTime && (i.value = Math.max(s.startTime - G(), 0), i.entries.push(s), t(!0)));
      });
    });
    a && (t = g(e, i, ye, n.reportAllChanges), M(function(o) {
      i = T("FCP"), t = g(e, i, ye, n.reportAllChanges), se(function() {
        i.value = performance.now() - o.timeStamp, t(!0);
      });
    }));
  });
}, Se = [0.1, 0.25], q = { passive: !0, capture: !0 }, Ze = new Date(), Ee = function(e, n) {
  k || (k = n, A = e, Oe = new Date(), _e(removeEventListener), Ae());
}, Ae = function() {
  if (A >= 0 && A < Oe - Ze) {
    var e = { entryType: "first-input", name: k.type, target: k.target, cancelable: k.cancelable, startTime: k.timeStamp, processingStart: k.timeStamp + A };
    J.forEach(function(n) {
      n(e);
    }), J = [];
  }
}, et = function(e) {
  if (e.cancelable) {
    var n = (e.timeStamp > 1e12 ? new Date() : performance.now()) - e.timeStamp;
    e.type == "pointerdown" ? function(t, r) {
      var i = function() {
        Ee(t, r), o();
      }, a = function() {
        o();
      }, o = function() {
        removeEventListener("pointerup", i, q), removeEventListener("pointercancel", a, q);
      };
      addEventListener("pointerup", i, q), addEventListener("pointercancel", a, q);
    }(n, e) : Ee(n, e);
  }
}, _e = function(e) {
  ["mousedown", "keydown", "touchstart", "pointerdown"].forEach(function(n) {
    return e(n, et, q);
  });
}, ke = [100, 300], tt = function(e, n) {
  n = n || {}, z(function() {
    var t, r = me(), i = T("FID"), a = function(u) {
      u.startTime < r.firstHiddenTime && (i.value = u.processingStart - u.startTime, i.entries.push(u), t(!0));
    }, o = function(u) {
      u.forEach(a);
    }, s = B("first-input", o);
    t = g(e, i, ke, n.reportAllChanges), s && $(ue(function() {
      o(s.takeRecords()), s.disconnect();
    })), s && M(function() {
      var u;
      i = T("FID"), t = g(e, i, ke, n.reportAllChanges), J = [], A = -1, k = null, _e(addEventListener), u = a, J.push(u), Ae();
    });
  });
}, He = 0, Y = 1 / 0, j = 0, nt = function(e) {
  e.forEach(function(n) {
    n.interactionId && (Y = Math.min(Y, n.interactionId), j = Math.max(j, n.interactionId), He = j ? (j - Y) / 7 + 1 : 0);
  });
}, ze = function() {
  return oe ? He : performance.interactionCount || 0;
}, rt = function() {
  "interactionCount" in performance || oe || (oe = B("event", nt, { type: "event", buffered: !0, durationThreshold: 0 }));
}, we = [200, 500], je = 0, Me = function() {
  return ze() - je;
}, b = [], Z = {}, Ce = function(e) {
  var n = b[b.length - 1], t = Z[e.interactionId];
  if (t || b.length < 10 || e.duration > n.latency) {
    if (t)
      t.entries.push(e), t.latency = Math.max(t.latency, e.duration);
    else {
      var r = { id: e.interactionId, latency: e.duration, entries: [e] };
      Z[r.id] = r, b.push(r);
    }
    b.sort(function(i, a) {
      return a.latency - i.latency;
    }), b.splice(10).forEach(function(i) {
      delete Z[i.id];
    });
  }
}, it = function(e, n) {
  (function(t, r) {
    r = r || {}, z(function() {
      var i;
      rt();
      var a, o = T("INP"), s = function(v) {
        v.forEach(function(h) {
          h.interactionId && Ce(h), h.entryType === "first-input" && !b.some(function(F) {
            return F.entries.some(function(de) {
              return h.duration === de.duration && h.startTime === de.startTime;
            });
          }) && Ce(h);
        });
        var m, f = (m = Math.min(b.length - 1, Math.floor(Me() / 50)), b[m]);
        f && f.latency !== o.value && (o.value = f.latency, o.entries = f.entries, a());
      }, u = B("event", s, { durationThreshold: (i = r.durationThreshold) !== null && i !== void 0 ? i : 40 });
      a = g(t, o, we, r.reportAllChanges), u && ("interactionId" in PerformanceEventTiming.prototype && u.observe({ type: "first-input", buffered: !0 }), $(function() {
        s(u.takeRecords()), o.value < 0 && Me() > 0 && (o.value = 0, o.entries = []), a(!0);
      }), M(function() {
        b = [], je = ze(), o = T("INP"), a = g(t, o, we, r.reportAllChanges);
      }));
    });
  })(function(t) {
    (function(r) {
      if (r.entries.length) {
        var i = r.entries.sort(function(a, o) {
          return o.duration - a.duration || o.processingEnd - o.processingStart - (a.processingEnd - a.processingStart);
        })[0];
        r.attribution = { eventTarget: W(i.target), eventType: i.name, eventTime: i.startTime, eventEntry: i, loadState: D(i.startTime) };
      } else
        r.attribution = {};
    })(t), e(t);
  }, n);
}, Le = [2500, 4e3], ee = {}, xe = [800, 1800], at = function e(n) {
  document.prerendering ? z(function() {
    return e(n);
  }) : document.readyState !== "complete" ? addEventListener("load", function() {
    return e(n);
  }, !0) : setTimeout(n, 0);
}, ot = function(e, n) {
  n = n || {};
  var t = T("TTFB"), r = g(e, t, xe, n.reportAllChanges);
  at(function() {
    var i = I();
    if (i) {
      var a = i.responseStart;
      if (a <= 0 || a > performance.now())
        return;
      t.value = Math.max(a - G(), 0), t.entries = [i], r(!0), M(function() {
        t = T("TTFB", 0), (r = g(e, t, xe, n.reportAllChanges))(!0);
      });
    }
  });
}, st = function(e) {
  e.forEach(function(n) {
    n.identifier && E({ attribution: { identifier: n.identifier }, name: "ET", rating: null, value: n.startTime });
  });
}, ut = function(e) {
  e.forEach(function(n) {
    if (c.isResourceTiming && _("resourceTiming", n), n.decodedBodySize && n.initiatorType) {
      var t = n.decodedBodySize / 1e3;
      re.value[n.initiatorType] += t, re.value.total += t;
    }
  });
}, ct = function() {
  (function(e, n) {
    ot(function(t) {
      (function(r) {
        if (r.entries.length) {
          var i = r.entries[0], a = i.activationStart || 0, o = Math.max(i.domainLookupStart - a, 0), s = Math.max(i.connectStart - a, 0), u = Math.max(i.requestStart - a, 0);
          r.attribution = { waitingTime: o, dnsTime: s - o, connectionTime: u - s, requestTime: r.value - u, navigationEntry: i };
        } else
          r.attribution = { waitingTime: 0, dnsTime: 0, connectionTime: 0, requestTime: 0 };
      })(t), e(t);
    }, n);
  })(function(e) {
    e.value > 0 && E(e);
  }, c.reportOptions.ttfb), function(e, n) {
    (function(t, r) {
      r = r || {}, be(ue(function() {
        var i, a = T("CLS", 0), o = 0, s = [], u = function(m) {
          m.forEach(function(f) {
            if (!f.hadRecentInput) {
              var h = s[0], F = s[s.length - 1];
              o && f.startTime - F.startTime < 1e3 && f.startTime - h.startTime < 5e3 ? (o += f.value, s.push(f)) : (o = f.value, s = [f]);
            }
          }), o > a.value && (a.value = o, a.entries = s, i());
        }, v = B("layout-shift", u);
        v && (i = g(t, a, Se, r.reportAllChanges), $(function() {
          u(v.takeRecords()), i(!0);
        }), M(function() {
          o = 0, a = T("CLS", 0), i = g(t, a, Se, r.reportAllChanges), se(function() {
            return i();
          });
        }), setTimeout(i, 0));
      }));
    })(function(t) {
      (function(r) {
        if (r.entries.length) {
          var i = r.entries.reduce(function(s, u) {
            return s && s.value > u.value ? s : u;
          });
          if (i && i.sources && i.sources.length) {
            var a = (o = i.sources).find(function(s) {
              return s.node && s.node.nodeType === 1;
            }) || o[0];
            if (a)
              return void (r.attribution = { largestShiftTarget: W(a.node), largestShiftTime: i.startTime, largestShiftValue: i.value, largestShiftSource: a, largestShiftEntry: i, loadState: D(i.startTime) });
          }
        }
        var o;
        r.attribution = {};
      })(t), e(t);
    }, n);
  }(function(e) {
    return E(e);
  }, c.reportOptions.cls), function(e, n) {
    be(function(t) {
      (function(r) {
        if (r.entries.length) {
          var i = I(), a = r.entries[r.entries.length - 1];
          if (i) {
            var o = i.activationStart || 0, s = Math.max(0, i.responseStart - o);
            return void (r.attribution = { timeToFirstByte: s, firstByteToFCP: r.value - s, loadState: D(r.entries[0].startTime), navigationEntry: i, fcpEntry: a });
          }
        }
        r.attribution = { timeToFirstByte: 0, firstByteToFCP: r.value, loadState: D(Re()) };
      })(t), e(t);
    }, n);
  }(function(e) {
    return E(e);
  }, c.reportOptions.fcp), function(e, n) {
    tt(function(t) {
      (function(r) {
        var i = r.entries[0];
        r.attribution = { eventTarget: W(i.target), eventType: i.name, eventTime: i.startTime, eventEntry: i, loadState: D(i.startTime) };
      })(t), e(t);
    }, n);
  }(function(e) {
    return E(e);
  }, c.reportOptions.fid), function(e, n) {
    (function(t, r) {
      r = r || {}, z(function() {
        var i, a = me(), o = T("LCP"), s = function(m) {
          var f = m[m.length - 1];
          f && f.startTime < a.firstHiddenTime && (o.value = Math.max(f.startTime - G(), 0), o.entries = [f], i());
        }, u = B("largest-contentful-paint", s);
        if (u) {
          i = g(t, o, Le, r.reportAllChanges);
          var v = ue(function() {
            ee[o.id] || (s(u.takeRecords()), u.disconnect(), ee[o.id] = !0, i(!0));
          });
          ["keydown", "click"].forEach(function(m) {
            addEventListener(m, function() {
              return setTimeout(v, 0);
            }, !0);
          }), $(v), M(function(m) {
            o = T("LCP"), i = g(t, o, Le, r.reportAllChanges), se(function() {
              o.value = performance.now() - m.timeStamp, ee[o.id] = !0, i(!0);
            });
          });
        }
      });
    })(function(t) {
      (function(r) {
        if (r.entries.length) {
          var i = I();
          if (i) {
            var a = i.activationStart || 0, o = r.entries[r.entries.length - 1], s = o.url && performance.getEntriesByType("resource").filter(function(F) {
              return F.name === o.url;
            })[0], u = Math.max(0, i.responseStart - a), v = Math.max(u, s ? (s.requestStart || s.startTime) - a : 0), m = Math.max(v, s ? s.responseEnd - a : 0), f = Math.max(m, o ? o.startTime - a : 0), h = { element: W(o.element), timeToFirstByte: u, resourceLoadDelay: v - u, resourceLoadTime: m - v, elementRenderDelay: f - m, navigationEntry: i, lcpEntry: o };
            return o.url && (h.url = o.url), s && (h.lcpResourceEntry = s), void (r.attribution = h);
          }
        }
        r.attribution = { timeToFirstByte: 0, resourceLoadDelay: 0, resourceLoadTime: 0, elementRenderDelay: r.value };
      })(t), e(t);
    }, n);
  }(function(e) {
    return E(e);
  }, c.reportOptions.lcp), it(function(e) {
    return E(e);
  }, c.reportOptions.inp), c.isResourceTiming && ae("resource", ut), c.isElementTiming && ae("element", st);
}, ft = function(e) {
  var n = "usageDetails" in e ? e.usageDetails : {};
  _("storageEstimate", { quota: N(e.quota), usage: N(e.usage), caches: N(n.caches), indexedDB: N(n.indexedDB), serviceWorker: N(n.serviceWorkerRegistrations) });
}, S = { finalMarkToStepsMap: {}, startMarkToStepsMap: {}, active: {}, navigationSteps: {} }, mt = function() {
  S.startMarkToStepsMap = {}, S.finalMarkToStepsMap = {}, S.active = {}, S.navigationSteps = {};
}, dt = function(e) {
  if (e === void 0 && (e = {}), c.analyticsTracker = e.analyticsTracker, c.isResourceTiming = !!e.resourceTiming, c.isElementTiming = !!e.elementTiming, c.maxTime = e.maxMeasureTime || c.maxTime, c.reportOptions = e.reportOptions || c.reportOptions, c.steps = e.steps, c.onMarkStep = e.onMarkStep, pe()) {
    "PerformanceObserver" in P && ct(), document.hidden !== void 0 && document.addEventListener("visibilitychange", Ve);
    var n = function() {
      if (!pe())
        return {};
      var t = O.getEntriesByType("navigation")[0];
      if (!t)
        return {};
      var r = t.responseStart, i = t.responseEnd;
      return { fetchTime: i - t.fetchStart, workerTime: t.workerStart > 0 ? i - t.workerStart : 0, totalTime: i - t.requestStart, downloadTime: i - r, timeToFirstByte: r - t.requestStart, headerSize: t.transferSize - t.encodedBodySize || 0, dnsLookupTime: t.domainLookupEnd - t.domainLookupStart, redirectTime: t.redirectEnd - t.redirectStart };
    }();
    _("navigationTiming", n), n.redirectTime && E({ attribution: {}, name: "RT", rating: De("RT", n.redirectTime), value: n.redirectTime }), _("networkInformation", function() {
      if ("connection" in y) {
        var t = y.connection;
        return typeof t != "object" ? {} : (Pe = t.effectiveType, Ie = !!t.saveData, { downlink: t.downlink, effectiveType: t.effectiveType, rtt: t.rtt, saveData: !!t.saveData });
      }
      return {};
    }()), y && y.storage && typeof y.storage.estimate == "function" && y.storage.estimate().then(ft), c.steps && c.steps && (mt(), Object.entries(c.steps).forEach(function(t) {
      var r, i, a = t[0], o = t[1].marks, s = o[0], u = o[1], v = (i = S.startMarkToStepsMap[s]) !== null && i !== void 0 ? i : {};
      if (v[a] = !0, S.startMarkToStepsMap[s] = v, S.finalMarkToStepsMap[u]) {
        var m = S.finalMarkToStepsMap[u][s] || [];
        m.push(a), S.finalMarkToStepsMap[u][s] = m;
      } else
        S.finalMarkToStepsMap[u] = ((r = {})[s] = [a], r);
    }));
  }
}, ce, H, U, We, V, Je, l, p;
class pt extends $e {
  constructor({ memory: t, ...r }) {
    super({ ...r });
    C(this, U);
    /**
     * Получить потребляемую вкладкой память
     * */
    C(this, V);
    C(this, l);
    C(this, ce, null);
    C(this, H, !1);
    ve(this, H, t);
  }
  init(t) {
    this.setMeter(t), this._queue.setMeter(this._meter), dt({
      analyticsTracker: (r) => {
        const { metricName: i, data: a, navigatorInformation: o, navigationType: s, rating: u } = r;
        switch (i) {
          case "navigationTiming":
            a && a.timeToFirstByte && d(this, l, p).call(this, { metricName: "navigationTiming", attributes: a });
            break;
          case "networkInformation":
            a && a.effectiveType && d(this, l, p).call(this, { metricName: "networkInformation", attributes: a });
            break;
          case "FP":
            d(this, l, p).call(this, { metricName: "fp", value: a, attributes: { rating: u } });
            break;
          case "FCP":
            d(this, l, p).call(this, { metricName: "fcp", value: a, attributes: { rating: u } });
            break;
          case "FID":
            d(this, l, p).call(this, { metricName: "fid", value: a, attributes: { rating: u } });
            break;
          case "LCP":
            d(this, l, p).call(this, { metricName: "lcp", value: a, attributes: { rating: u } });
            break;
          case "CLS":
            d(this, l, p).call(this, { metricName: "cls", value: a, attributes: { rating: u } });
            break;
          case "TTFB":
            d(this, l, p).call(this, { metricName: "ttfb", value: a, attributes: { rating: u } });
            break;
          case "TBT":
            d(this, l, p).call(this, { metricName: "tbt", value: a, attributes: { rating: u } });
            break;
          case "INP":
            d(this, l, p).call(this, { metricName: "inp", value: a, attributes: { rating: u } });
            break;
          case "storageEstimate":
            d(this, l, p).call(this, { metricName: "storageEstimate", attributes: a });
            break;
        }
      }
    }), le(this, H) && d(this, U, We).call(this);
  }
}
ce = new WeakMap(), H = new WeakMap(), U = new WeakSet(), We = function() {
  const t = d(this, V, Je).call(this);
  if (!t)
    return;
  const { usedMemoryMB: r, totalMemoryMB: i } = t;
  function a(o, s) {
    return {
      metricName: o,
      value: s
    };
  }
  d(this, l, p).call(this, a("used_memory_mb", r)), d(this, l, p).call(this, a("total_memory_mb", i));
}, V = new WeakSet(), Je = function() {
  let t;
  try {
    const r = window.performance || window.webkitPerformance || window.msPerformance || window.mozPerformance;
    if (r) {
      const i = r.memory;
      if (i) {
        const a = (i.usedJSHeapSize / 1048576).toFixed(2), o = (i.totalJSHeapSize / (1024 * 1024)).toFixed(2);
        t = {
          usedMemoryMB: a,
          totalMemoryMB: o
        };
      }
    }
  } catch (r) {
    console.error(r);
  }
  return t;
}, l = new WeakSet(), p = function(t) {
  this.addInQueue({
    type: "performance",
    name: `${this._eventNamePrefix}${t.metricName}`,
    labels: {
      pagePath: this.handlePagePath(window.location.pathname),
      ...t.attributes,
      ...this._meter.browserInfo,
      ...this._customAttributes,
      ...this._meter.gaId && {
        gaId: this._meter.gaId
      }
    },
    ...t.value !== void 0 && { value: t.value }
  });
};
export {
  pt as default
};
